import { MultiSelect } from '@mantine/core';
import inputClasses from '../input.module.css';
import { defaultInputProps } from '../default-props';
// TODO: Style the dropdown
export const multiselectProps = MultiSelect.extend({
    classNames: inputClasses,
    defaultProps: defaultInputProps,
});
